import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { Gallery } from "@/components/landing/Gallery";
import { Process } from "@/components/landing/Process";
import { KitchenCalculator } from "@/components/landing/KitchenCalculator";
import { Coverage } from "@/components/landing/Coverage";
import { Testimonials } from "@/components/landing/Testimonials";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { CostCalculator } from "@/components/landing/CostCalculator";

const Home = () => (
  <div className="bg-[#FAF6F0] text-[#0D2121] font-sans antialiased" data-testid="griham-home-page">
    <Navbar />
    <Hero />
    <About />
    <Services />
    <Gallery />
    <Process />
    <KitchenCalculator />
    <Coverage />
    <Testimonials />
    <Faq />
    <Contact />
    <Footer />
    <CostCalculator />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
